import React from 'react';
import { Outlet } from 'react-router-dom';
import { CssBaseline, Box, Link, Typography } from '@mui/material';

const TEST_HOSTS = ['fsmdata.com', 'localhost', '127.0.0.1'];

const isTestEnvironment = () =>
  TEST_HOSTS.some((host) => window.location.hostname.endsWith(host));

const headlineStyles = {
  fontWeight: '800',
  fontSize: '22px',
  lineHeight: '30px',
};

const desktopHeadlineStyles = {
  fontSize: '32px',
  lineHeight: '40px',
};

const Layout = () => {
  return (
    <div style={{ height: '100%' }}>
      <CssBaseline />
      <main className='root' style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        {isTestEnvironment() && (
          <Box
            sx={{
              backgroundColor: '#FFF4CE',
              borderBottom: '1px solid #F0DFA0',
              px: '20px',
              py: '6px',
              textAlign: 'center',
            }}
          >
            <Typography sx={{ fontSize: '12px', lineHeight: '16px', color: '#6B5200' }}>
              Testing environment — bookings made here are not real.
            </Typography>
          </Box>
        )}
        <Box sx={[
          {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
          },
          (theme) => ({
            [theme.breakpoints.up('sm')]: {
              flexDirection: 'row',
            },
          }),
        ]}>
          <Box sx={[
            {
              display: 'flex',
              px: '20px',
              py: '14px',
              borderBottom: '1px solid #DDDFDD',
              '& img': { maxWidth: '120px' },
            },
            (theme) => ({
              [theme.breakpoints.up('sm')]: {
                display: 'none',
              },
            }),
          ]}>
            <img src="/lucky-logo.svg" alt="Lucky Services" />
          </Box>

          <Box sx={[
            {
              order: 1,
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: '20px',
              py: '32px',
            },
            (theme) => ({
              [theme.breakpoints.up('sm')]: {
                order: 2,
                py: '64px',
                backgroundColor: '#F7F9F7',
              },
            }),
          ]}>
            <Outlet />
          </Box>

          <Box sx={[
            {
              order: 2,
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: '20px',
              py: '32px',
              borderTop: '1px solid #DDDFDD',
            },
            (theme) => ({
              [theme.breakpoints.up('sm')]: {
                order: 1,
                py: '64px',
                borderTop: 'none',
                borderRight: '1px solid #DDDFDD',
              },
            }),
          ]}>
            <Box sx={{ maxWidth: '450px', width: '100%' }}>
              <Box sx={[
                {
                  display: 'none',
                  mb: '46px',
                  maxWidth: '260px',
                  '& img': { maxWidth: '100%' },
                },
                (theme) => ({
                  [theme.breakpoints.up('sm')]: {
                    display: 'flex',
                  },
                }),
              ]}>
                <img src="/lucky-logo.svg" alt="Lucky Services" />
              </Box>
              <Typography
                sx={[
                  { ...headlineStyles, color: '#0A1E0B', mb: '16px' },
                  (theme) => ({
                    [theme.breakpoints.up('sm')]: desktopHeadlineStyles,
                  }),
                ]}
                variant="h1"
                component="div">
                SO YOU CAN FOCUS ON THE THINGS <Typography
                  sx={[
                    { ...headlineStyles, color: '#3D8F44' },
                    (theme) => ({
                      [theme.breakpoints.up('sm')]: desktopHeadlineStyles,
                    }),
                  ]}
                  variant="h1"
                  component="span">YOU LOVE</Typography>
              </Typography>
              <Link
                href="https://goluckyservices.com"
                sx={{ textTransform: 'none', fontSize: '14px', letterSpacing: 'normal' }}>
                goluckyservices.com
              </Link>
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
};

export default Layout;
